export const ResponseStatus = {
  SUCCESS: 'success',
  ERROR: 'error',
  PENDING: 'pending',
  RUNNING: 'running',
  IN_PROGRESS: 'in_progress',
};

export const StatusCode = {
  SUCCESS: 'SUCCESS',
  COMPLETED: 'COMPLETED',
  ERROR: 'ERROR',
  IN_PROGRESS: 'IN_PROGRESS',
  SCHEDULED: 'SCHEDULED',
  DELETED: 'DELETED',
};
